import { route } from "./routes.js";
import { z } from "zod";
//#region src/recovery-codes.ts
/**
* `/v1/admin/recovery-codes/*` — the two routes the admin app's auth-providers page calls through
* its recovery-codes modal.
*
* Producer: `AdminRecoveryCodesController` and `RecoveryCodeService` in
* `cloud/dp/core-api/src/`. Consumer: the admin app's `AdminClient`.
*
* Permission keys: the class default is `settings:identity:manage` because `regenerate` returns raw
* recovery codes once, which is credential issuance; `count` overrides it to
* `settings:identity:read` because it is a bare integer.
*
* Neither route takes a body, a query or a parameter, so neither has a request schema and neither
* has a path builder. The shell and the controller agree on both response shapes.
*
* Direction rule (R-28): every response schema here is `z.object`, so a member core-api adds is
* stripped rather than refused and one new column cannot red every page that reads the route.
* Every request schema is `z.strictObject`, so a key the server would reject is refused before
* the request leaves the client. No shape in this file travels in both directions.
*/
/**
* `GET /v1/admin/recovery-codes/count` — how many unused codes remain. Requires
* `settings:identity:read`.
*/
const GET_RECOVERY_CODE_COUNT_ROUTE = route("GET", "/v1/admin/recovery-codes/count");
/**
* `POST /v1/admin/recovery-codes/regenerate` — mint a fresh set and invalidate the old one.
* Status 200, not 201. Requires `settings:identity:manage`.
*/
const REGENERATE_RECOVERY_CODES_ROUTE = route("POST", "/v1/admin/recovery-codes/regenerate");
/**
* The body of `GET /v1/admin/recovery-codes/count` — `{ count }`, the number of codes the
* organization has left. Zero is a normal answer, not an error.
*/
const getRecoveryCodeCountResponseSchema = z.object({ count: z.number().int().min(0) });
/**
* The body of `POST /v1/admin/recovery-codes/regenerate` — the raw codes, returned once and never
* readable again. The caller must show them before it navigates away; the server keeps only hashes.
*/
const regenerateRecoveryCodesResponseSchema = z.object({ codes: z.array(z.string()) });
/** Every route this file names, for `route-census.ts`. */
const recoveryCodesRoutes = Object.freeze([GET_RECOVERY_CODE_COUNT_ROUTE, REGENERATE_RECOVERY_CODES_ROUTE]);
//#endregion
export { GET_RECOVERY_CODE_COUNT_ROUTE, REGENERATE_RECOVERY_CODES_ROUTE, getRecoveryCodeCountResponseSchema, recoveryCodesRoutes, regenerateRecoveryCodesResponseSchema };

//# sourceMappingURL=recovery-codes.js.map